import Circle from "../LogoSVG/Circle";
import netcompanyLogo from "../../public/netcompany2.png";
import Arrow from "../LogoSVG/Arrow";

export const listTech = [
  "ASP.NET Core",
  "C#",
  "NextJs",
  "TypeScript",
  "Elasticsearch",
  "CI/CD",
  "IaaS",
  "Contentful",
  "Microsoft Azure",
];

function NetcompanyDesktop({ index, hoveredIndex, setHoveredIndex }: any) {
  return (
    <div
      className={`flex flex-row pb-8 items-start ${
        hoveredIndex == undefined || hoveredIndex == index ? "" : "opacity-55"
      }`}
      onMouseEnter={() => setHoveredIndex(index)}
      onMouseLeave={() => setHoveredIndex(undefined)}
    >
      <a
        className="flex flex-col items-start "
        href="https://netcompany.com/"
        target="_blank"
      >
        <p className="w-[180px] items-start text-gray-4">Jul 2024 - Jul 2025</p>
        <div className="w-[90px] h-[90px] 2xl:h-[110px] 2xl:w-[110px] mt-8 ml-8 overflow-hidden rounded-full">
          <img
            src={netcompanyLogo}
            alt="logo"
            className="object-cover w-full h-full"
          />
        </div>
      </a>

      <a
        className="pl-16 2xl:pl-24 "
        href="https://netcompany.com/"
        target="_blank"
      >
        <div
          className={`flex flex-row items-center mb-2 font-medium text-[18px] `}
          style={{ color: hoveredIndex === index ? "#ebdd86" : "inherit" }}
        >
          <p className="">Software Engineer | Netcompany Group A/S</p>
          {/* <Circle className="mx-2 h-1.5 w-1.5 " /> */}
          {/* <p className="mr-4 ">Netcompany Group A/S</p> */}
          <Arrow
            className={`transition-transform duration-250 mb-1 ml-2 ease-in-out ${
              hoveredIndex === index ? "-translate-y-2 translate-x-1" : ""
            }`}
          />
        </div>

        <div className=" text-gray-5">
          <div className="flex flex-row mb-1.5">
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
            <p className="text-gray-4 w-[580px]">
              Optimized ElasticSearch indexing service for FIFA’s products
              (FIFACom/ FIFA Mediahub/ InsideFIFA) via sitemaps and webhooks
            </p>
          </div>

          <div className="flex flex-row mb-1.5  ">
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
            <p className="text-gray-4 w-[600px] ">
              Improved search API for FIFA websites, handling nearly 8M
              monthly requests and mitigating up to 100K monthly failed requests
              during FCWC
            </p>
          </div>

          <div className="flex flex-row mb-1.5">
            <Circle className="mr-3 h-1.5 w-1.5 mt-2" />
            <p className="text-gray-4 w-[600px]">
              Built and maintained custom CMS Contentful application services,
              CI/CD pipelines to help FIFA editors publish content
            </p>
          </div>
        </div>
      </a>
    </div>
  );
}

export default NetcompanyDesktop;
